module.exports = __webpack_public_path__ + "dash_20_app_assets/img/smile.c3bd9cdb.png";